import React__default from 'react';
import { g as getChannelTitle } from '../../chunks/bundle-BH8ohfFx.js';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import { u as useLocalization } from '../../chunks/bundle-CIN9yQRB.js';
import { useGroupChannelListContext } from '../context.js';
import { G as GroupChannelListItemView } from '../../chunks/bundle-V4PrrT67.js';
import '../../chunks/bundle-C7jYHvwG.js';
import '../../chunks/bundle-BeUKuH7h.js';
import '../../chunks/bundle-Dl9NVsui.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DUTyBaXr.js';
import '../../chunks/bundle-DImSV9VW.js';
import '../../chunks/bundle-pOZPN8hk.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CDjVXDOc.js';
import '../../chunks/bundle-DkviGBGz.js';
import '../../chunks/bundle-Bzt5nDi4.js';
import '../../chunks/bundle-yLTgHCRG.js';
import '../../withSendbird.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-gQ2a8Eki.js';
import '../../chunks/bundle-MyLy9AIu.js';
import 'react-dom';
import '../../chunks/bundle-DfDrbjM5.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-CLonR-iH.js';
import '../../chunks/bundle-C6-Ix-Lk.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-Cq6wCLlD.js';
import '../../chunks/bundle-eYHtE5ry.js';
import '../../GroupChannel/components/TypingIndicator.js';
import '../../ui/Badge.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-CbEyAimK.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BR3O1lZq.js';
import '../../chunks/bundle-TGosz9cX.js';
import '../../ui/MentionUserLabel.js';
import '../../chunks/bundle-BMygDCXK.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-Ci2fMtNJ.js';
import '../../chunks/bundle-_-FiwcfQ.js';

var GroupChannelListItem = function (_a) {
    var _b, _c, _d;
    var channel = _a.channel, isSelected = _a.isSelected, isTyping = _a.isTyping, renderChannelAction = _a.renderChannelAction, onLeaveChannel = _a.onLeaveChannel, onClick = _a.onClick, tabIndex = _a.tabIndex;
    var config = useSendbirdStateContext().config;
    var stringSet = useLocalization().stringSet;
    var _e = useGroupChannelListContext(), _f = _e.isTypingIndicatorEnabled, isTypingIndicatorEnabled = _f === void 0 ? false : _f, _g = _e.isMessageReceiptStatusEnabled, isMessageReceiptStatusEnabled = _g === void 0 ? false : _g;
    var userId = config.userId;
    var isMessageStatusEnabled = isMessageReceiptStatusEnabled
        && (!((_b = channel.lastMessage) === null || _b === void 0 ? void 0 : _b.isAdminMessage()))
        && ((_d = (_c = channel.lastMessage) === null || _c === void 0 ? void 0 : _c.sender) === null || _d === void 0 ? void 0 : _d.userId) === userId;
    return (React__default.createElement(GroupChannelListItemView, { channel: channel, tabIndex: tabIndex, channelName: getChannelTitle(channel, userId, stringSet), isTyping: isTypingIndicatorEnabled && isTyping, isSelected: isSelected, isMessageStatusEnabled: isMessageStatusEnabled, onClick: onClick, onLeaveChannel: onLeaveChannel, renderChannelAction: renderChannelAction }));
};

export { GroupChannelListItem };
//# sourceMappingURL=GroupChannelListItem.js.map
